import { AppNames } from 'parkchirp-shared/enums';

export const FILE_UPLOAD_MAXIMUM = 15;

export const isTenantPortal = process.env.NEXT_PUBLIC_APP_NAME === AppNames.TENANT_PORTAL;
export const isOwnerPortal = process.env.NEXT_PUBLIC_APP_NAME === AppNames.OWNER_PORTAL;
export const isAdminDashboard = process.env.NEXT_PUBLIC_APP_NAME === AppNames.ADMIN_DASHBOARD;
export const US_TIMEZONES = [
	'America/New_York',
	'America/Detroit',
	'America/Kentucky/Louisville',
	'America/Kentucky/Monticello',
	'America/Indiana/Indianapolis',
	'America/Indiana/Vincennes',
	'America/Indiana/Winamac',
	'America/Indiana/Marengo',
	'America/Indiana/Petersburg',
	'America/Indiana/Vevay',
	'America/Chicago',
	'America/Indiana/Tell_City',
	'America/Indiana/Knox',
	'America/Menominee',
	'America/North_Dakota/Center',
	'America/North_Dakota/New_Salem',
	'America/North_Dakota/Beulah',
	'America/Denver',
	'America/Boise',
	'America/Phoenix',
	'America/Los_Angeles',
	'America/Anchorage',
	'America/Juneau',
	'America/Sitka',
	'America/Metlakatla',
	'America/Yakutat',
	'America/Nome',
	'America/Adak',
	'Pacific/Honolulu',
];
